module.exports = "<ul :class=ulClasses> <slot></slot> </ul>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/collections/collection.vue
 ** module id = 224
 ** module chunks = 0
 **/